import React, {PropsWithChildren, useRef, useState} from 'react';
import b_ from 'b_';

import {ERROR_CLASS_NAME} from 'client/common/utils/errors';

import {Button, Icon, Popup} from 'client/common/components/lego';
import {IPopupProps} from '@yandex-lego/components/Popup/Popup';

import './block-input.css';

const b = b_.with('block-input');

type BlockInputProps = PropsWithChildren<{
    className?: string;
    title?: string;
    description?: string | React.ReactNode;
    popupContent?: React.ReactNode;
    popupOptions?: IPopupProps;
    error?: {
        message?: string
    };
}>;

export default function BlockInput(props: BlockInputProps) {
    const {children, className = '', title, description, error, popupContent} = props;
    const wrapperRef = useRef(null);

    const [displayPopup, setDisplayPopup] = useState(false);

    return (
        <div className={`${b()} ${className}`}>
            {title && (
                <div className={b('title-wrapper')}>
                    <label className={b('text')}>{title}</label>

                    {popupContent && (
                        <Button
                            className={b('help-icon')}
                            innerRef={wrapperRef}
                            icon={(mix: string) => <Icon className={mix} type='help' />}
                            onClick={() => setDisplayPopup(true)}
                            size='icon'
                            view='clear'
                        />
                    )}
                </div>
            )}
            {description && <div className={b('description')}>{description}</div>}
            <div className={b('content')}>{children}</div>
            {error && <span className={ERROR_CLASS_NAME}>{error.message}</span>}

            {popupContent && (
                <Popup
                    anchor={wrapperRef}
                    onClose={() => setDisplayPopup(false)}
                    className={b('info-popup')}
                    direction='bottom'
                    target='anchor'
                    view='default'
                    visible={displayPopup}
                >
                    {popupContent}
                </Popup>
            )}
        </div>
    );
}
